import React, { useState, useEffect } from 'react';
import SelectBox from '../common/SelectBox';
import AdminNavigation from './AdminNavigation';
import subDays from 'date-fns/subDays';
import Input from '../common/Input';
import { format } from 'date-fns';
import { CSVLink } from 'react-csv';
import DataTable from '../common/DataTable';
import { getSalesReport } from '../service/saleService';
import { toast } from 'react-toastify';
import { getVendorAccounts } from '../service/vendorService';
import Loading from '../common/Loading';
import { isAdmin } from '../service/authService';

const SalesReport = () => {
   const [startDate, setStartDate] = useState(subDays(new Date(), 2));
   const [endDate, setEndDate] = useState(new Date());
   const [items, setItems] = useState([]);
   const [accounts, setAccounts] = useState([]);
   const [account, setAccount] = useState({});
   const [loading, isLoading] = useState(false);
   const [done, setDone] = useState(true);
   const [product, setProduct] = useState({
      productId: 1,
      productDesc: 'ELECTRICITY',
   });
   const user = JSON.parse(localStorage.getItem('user'));

   const products = [
      {
         productId: 1,
         productDesc: 'ELECTRICITY',
      },
      {
         productId: 2,
         productDesc: 'AIRTIME',
      },
   ];

   const columns = [
      {
         columnCaption: 'TransactionId',
         columnKey: 'transactionId',
         content: (item) => <span style={{ fontSize: 10 }}>{item.transactionId}</span>,
      },
      {
         columnCaption: 'Ext TransactionId',
         columnKey: 'externalTransactionId',
         content: (item) => <span style={{ fontSize: 10 }}>{item.externalTransactionId}</span>,
      },
      {
         columnCaption: 'Msisdn',
         columnKey: 'msisdn',
      },
      {
         columnCaption: 'Receiver Id',
         columnKey: 'receiverId',
      },
      {
         columnCaption: 'Product',
         columnKey: 'product',
      },
      {
         columnCaption: 'PaymentTime',
         columnKey: 'paymentDateTime',
      },
      {
         columnCaption: 'Status',
         columnKey: 'status',
      },
      {
         columnCaption: 'Token',
         columnKey: 'token',
      },
      {
         columnCaption: 'Amount',
         columnKey: 'tokenAmount',
      },
   ];
   const exportHeaders = [
      { label: 'TransactionId', key: 'transactionId' },
      { label: 'Ext TransactionId', key: 'externalTransactionId' },
      { label: 'Msisdn', key: 'msisdn' },
      { label: 'Receiver Id', key: 'receiverId' },
      { label: 'Product', key: 'product' },
      { label: 'PaymentTime', key: 'paymentDateTime' },
      { label: 'Token', key: 'token' },
      { label: 'Amount', key: 'tokenAmount' },
   ];

   const fetchVendorAccounts = () => {
      getVendorAccounts()
         .then((response) => {
            const vendorAccounts = response.data.data;
            const checkAdmin = isAdmin();
            if (checkAdmin) {
               setAccounts((prevState) => {
                  return prevState.concat(vendorAccounts);
               });
            } else {
               const newAccounts = user.accounts;
               setAccounts(newAccounts);
            }
         })
         .catch((error) => {
            toast.error('Error occurs while fetching vendor accounts');
         });
   };

   useEffect(fetchVendorAccounts, []);

   const handleSubmit = (e) => {
      e.preventDefault();
      const requestData = {
         startDate: format(startDate, 'yyyy-MM-dd'),
         endDate: format(endDate, 'yyyy-MM-dd'),
         vendorAccountId: account.vendorAccountId,
         productId: product.productId,
      };
      console.log(requestData);
      isLoading(true);
      setDone(false);
      getSalesReport(requestData)
         .then((result) => {
            const records = result.data.data;
            isLoading(false);
            if (!records) {
               toast.info('No records', { autoClose: 2000 });
               setItems([]);
            } else {
               setTimeout(() => {
                  setItems(records);
                  setDone(true);
               }, 500);
            }
         })
         .catch((error) => {
            setDone(true);
            toast.error('Error while fetching sales report records', { autoClose: 2000 });
            console.dir(error);
         });
   };

   return (
      <div className='container-fluid'>
         <div className='row'>
            <div className='col-md-2'>
               <AdminNavigation />
            </div>
            <div className='col-md-10'>
               <form className='form' onSubmit={handleSubmit}>
                  <div className='form-row'>
                     <div className='form-group col-md-3'>
                        <label htmlFor='startDate'>Start Date</label>
                        <Input
                           type='date'
                           selected={startDate}
                           onChange={(date) => setStartDate(date)}
                           dateFormat='dd/MM/yyyy'
                           id='startDate'
                           name='startDate'
                           className='form-control form-control-sm custom-input'
                        />
                     </div>
                     <div className='form-group col-md-3'>
                        <label htmlFor='endDate'>End Date</label>
                        <Input
                           id='endDate'
                           name='endDate'
                           label='End Date'
                           dateFormat='dd/MM/yyyy'
                           type='date'
                           selected={endDate}
                           onChange={(date) => setEndDate(date)}
                           className='form-control form-control-sm custom-input'
                        />
                     </div>
                  </div>
                  <div className='form-row'>
                     <div className='form-group col-md-6'>
                        <SelectBox
                           name='vendorAccount'
                           label='Vendor Account Id'
                           getOptionLabel={({ vendorAccountName }) => vendorAccountName}
                           getOptionValue={(option) => option}
                           value={account}
                           options={accounts}
                           onChange={(selected) => setAccount(selected)}
                           placeholder={'Search By ...'}
                        />
                     </div>
                  </div>
                  <div className='form-row'>
                     <div className='form-group col-md-6'>
                        <SelectBox
                           name='product'
                           label='Product'
                           getOptionLabel={({ productDesc }) => productDesc}
                           getOptionValue={(productId) => productId}
                           value={product}
                           options={products}
                           onChange={(selected) => setProduct(selected)}
                           placeholder={'Search By ...'}
                        />
                     </div>
                  </div>
                  <button className='btn btn-primary btn-sm search-button mr-2' type='submit'>
                     Search
                  </button>
               </form>
               <div className='mt-3 form'>
                  {!done ? (
                     <div className='d-flex justify-content-center align-items-center'>
                        <Loading loading={loading} />
                     </div>
                  ) : (
                     <>
                        <div className='d-flex justify-content-between'>
                           <div className='mb-2'>
                              <CSVLink
                                 data={items}
                                 headers={exportHeaders}
                                 filename={`sales_records_${account.vendorAccountName}.csv`}
                                 target='_blank'
                                 className='btn-link-custom font-italic font-weight-normal'
                              >
                                 Export CSV
                              </CSVLink>
                           </div>
                        </div>
                        {/* <DataTable items={items} fontClassName={'table-font-sm'} pageSize={5000} columns={columns} /> */}
                     </>
                  )}
               </div>
            </div>
         </div>
      </div>
   );
};

export default SalesReport;
